import { Camelized } from 'humps';
import { IGameDetails } from 'libs/games/src/hooks/api/getInnerGamesIds';
import { fillGameLiveDataMaps } from '../../normalize';
import { GamesStorageType } from '../../types';

type GetPragmaticInnerGamesIdsStatePreparator = (args: {
  data: Camelized<{
    games: IGameDetails[];
  }>;
  state: GamesStorageType;
}) => GamesStorageType;

export const getPragmaticInnerGamesIdsStatePreparator: GetPragmaticInnerGamesIdsStatePreparator =
  ({ data, state }) => {
    const { launchIdToGameLiveData, innerGameIdToLaunchId } =
      fillGameLiveDataMaps(
        state.gamesLiveInfo.launchIdToGameLiveData,
        state.gamesLiveInfo.innerGameIdToLaunchId,
        data.games
      );
    return {
      ...state,
      gamesLiveInfo: {
        ...state.gamesLiveInfo,
        launchIdToGameLiveData,
        innerGameIdToLaunchId,
        isCmsPragmaticLiveDataLoaded: true
      }
    };
  };
